import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SearchResultComponent } from '../search-result/search-result.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-search-result-sprint',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './search-result-sprint.component.html',
  styleUrl: './search-result-sprint.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultSprintComponent extends SearchResultComponent {}
